const sampleData = [
  {
    date: "2017-08-01",
    invoice: "INV-5713114PQR",
    customer: "Cisco Systems",
    project: "CISCO-Image Processing CS",
    amount: 6302,
    paid: 6302,
    balance: 0,
    dueDate: "2017-08-31",
    lateDays: 0,
    paymentStatus: "Paid",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-31",
    invoice: "INV-5713113PQR",
    customer: "Ecker Design",
    project: "Design Revamp",
    amount: 500,
    paid: 0,
    balance: 500,
    dueDate: "2017-08-07",
    lateDays: 0,
    paymentStatus: "Not Due",
    invoiceStatus: "Draft",
  },
  {
    date: "2017-07-20",
    invoice: "INV-5713112PQR",
    customer: "Finisar",
    project: "Bonsai",
    amount: 1600,
    paid: 0,
    balance: 1600,
    dueDate: "2017-07-20",
    lateDays: 12,
    paymentStatus: "Late",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-18",
    invoice: "INV-5713111PQR",
    customer: "Cisco Systems",
    project: "CISCO-Image Processing CS",
    amount: 4302,
    paid: 0,
    balance: 4302,
    dueDate: "2017-08-17",
    lateDays: 0,
    paymentStatus: "Not Due",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-13",
    invoice: "INV-5713110PQR",
    customer: "Finisar",
    project: "Bonsai",
    amount: 21600,
    paid: 0,
    balance: 21600,
    dueDate: "2017-07-13",
    lateDays: 19,
    paymentStatus: "Late",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-07",
    invoice: "INV-571309PQR",
    customer: "Cisco Systems",
    project: "CISCO-Image Processing CS",
    amount: 14316.54,
    paid: 9998.5,
    balance: 4318.04,
    dueDate: "2017-08-06",
    lateDays: 0,
    paymentStatus: "Not Due",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-05",
    invoice: "INV-571308PQR",
    customer: "Finisar",
    project: "Bonsai",
    amount: 4000,
    paid: 0,
    balance: 4000,
    dueDate: "2017-07-05",
    lateDays: 27,
    paymentStatus: "Late",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-03",
    invoice: "INV-571307PQR",
    customer: "Cisco Systems",
    project: "CISCO-Image Processing CS",
    amount: 15001.5,
    paid: 15001.5,
    balance: 0,
    dueDate: "2017-08-02",
    lateDays: 0,
    paymentStatus: "Paid",
    invoiceStatus: "Invoiced",
  },
  {
    date: "2017-07-01",
    invoice: "INV-571306PQR",
    customer: "Ecker Design",
    project: "Design Revamp",
    amount: 500,
    paid: 0,
    balance: 500,
    dueDate: "2017-07-08",
    lateDays: 24,
    paymentStatus: "Late",
    invoiceStatus: "Invoiced",
  },
];
export default sampleData; // ✅ must have this
